import { render, staticRenderFns } from "./demo1.vue?vue&type=template&id=56aa9a5c&"
import script from "./demo1.vue?vue&type=script&lang=ts&"
export * from "./demo1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports